import { updates } from '@/mocks/homeMangaData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">最新快讯</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">韩漫推荐、日漫大全、国漫排行榜动态实时追踪</p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>

          <div className="flex flex-col gap-6">
            {updates.map((item, i) => (
              <div key={i} className="flex items-start gap-5 pl-[50px] relative">
                <span
                  className={`absolute left-0 top-1 w-[38px] h-[38px] rounded-full flex items-center justify-center text-xs font-bold text-background-50 ${
                    i === 0 ? 'bg-primary-500' : 'bg-secondary-500'
                  }`}
                >
                  {i === 0 ? <i className="ri-flashlight-line"></i> : i + 1}
                </span>
                <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}